import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { isNull } from 'lodash'
import { parseQ, itemLink, getLocationKey, isOnMobile } from '../utils'
import { themeColors } from '../styles/theme'
import {
  getItems,
  canLoadMoreItems,
  getItemsLoading,
  getTotalItems,
  getDistrictFilter,
  getWorld,
  makeGetCategoriesByWorld,
} from '../selectors'
import {
  loadItems,
  loadMoreItems,
  putItemsInCache,
  unloadItems,
  iWant,
  iWantNot,
} from '../actions'
import NotFound from '../common/NotFound'
import NoResults from '../common/NoResults'
import ObjectCard from '../common/ObjectCard'
import MobileSearchButton from '../common/MobileSearchButton'
import ObjectCardVirtual from '../common/ObjectCardVirtual'

class World extends PureComponent {
  componentDidMount() {
    if (this.props.world) {
      this.props.topBarSetTitle(this.props.world.nome)
      this.props.loadItems(
        {
          world_id: this.props.world.id,
          district_id: this.props.districtFilter,
          q: this.props.searchString,
        },
        getLocationKey(this.props.location)
      )
    }
  }

  componentWillReceiveProps(nextProps) {
    if (typeof nextProps.world !== 'undefined') {
      if (
        this.props.world !== nextProps.world ||
        this.props.searchString !== nextProps.searchString ||
        this.props.districtFilter !== nextProps.districtFilter
      ) {
        this.props.unloadItems()
        this.props.loadItems({
          world_id: nextProps.world.id,
          district_id: nextProps.districtFilter,
          q: nextProps.searchString,
        })
      }
      if (this.props.world !== nextProps.world) {
        this.props.topBarSetTitle(nextProps.world.nome)
        // Collapse filter when change world
        this.props.topBarCloseFilters()
      }
    }
  }

  componentWillUnmount() {
    this.props.unloadItems(false)
  }

  loadMore = () => {
    this.props.loadMoreItems({
      world_id: this.props.world.id,
      district_id: this.props.districtFilter,
      q: this.props.searchString,
    })
  }

  goToItemDetail = item => {
    this.props.putItemsInCache({
      cacheKey: getLocationKey(this.props.location),
    })
    this.props.history.push(itemLink(item))
  }

  render() {
    const {
      user,
      loadingWorlds,
      world,
      categories,
      loading,
      items,
      canLoadMoreItems,
      searchString,
      districtFilter,
      wantedLoadingById,
      iWant,
      iWantNot,
    } = this.props

    // Invalid world
    if (!loadingWorlds && !world) {
      return <NotFound />
    }

    return (
      <div>

        {/* <MobileSearchButton /> */}

        <ObjectCardVirtual
          items={items}
          reRenderFor={{ wantedLoadingById }}
          loadMore={this.loadMore}
          canLoadMoreItems={canLoadMoreItems}
          loading={loading}
          noContentRenderer={() => (
            <div>
              {!loading &&
                !isNull(items) &&
                <NoResults>
                  {searchString === '' &&
                    districtFilter === '' &&
                    <span>Nessun oggetto</span>}
                  {(searchString !== '' || districtFilter !== '') &&
                    <span>
                      Nessun oggetto per la ricerca
                      {searchString !== '' &&
                        <span>{' '}<b><i>{searchString}</i></b></span>}
                    </span>}
                  {/* {searchString !== '' &&
                    <div>
                      Prova a cercare nelle categorie: <br />
                      {' '}
                      {categories.map(category => (
                        <div key={category.slug} className="inline-flex">
                          <Link
                            className="colored-link"
                            to={`/category/${category.slug}?q=${searchString}`}>
                            {category.nome}
                          </Link>{' '}
                        </div>
                      ))}
                    </div>} */}
                </NoResults>}
            </div>
          )}
          renderObjectCard={item => {
            if (user) {
              return (
                <ObjectCard
                  item={item}
                  onClick={this.goToItemDetail}
                  wantedLoading={wantedLoadingById[item.id]}
                  withAttributeLinks
                  iWant={iWant}
                  iWantNot={iWantNot}
                />
              )
            } else {
              return (
                <ObjectCard
                  item={item}
                  onClick={this.goToItemDetail}
                  withAttributeLinks
                />
              )
            }
          }}
        />
        {!loading &&
          !isNull(items) &&
          <div className="w-100 text-center" style={{ paddingBottom: 30 }}>
            Prova a cercare nelle categorie: <br />
            {' '}
            {categories.map(category => (
              <div key={category.slug} className="inline-flex">
                <Link
                  className="colored-link"
                  to={`/category/${category.slug}?q=${searchString}`}>
                  {category.nome}
                </Link>{' '}
              </div>
            ))}
          </div>}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const worldSlug = ownProps.match.params.world
  const getCategories = makeGetCategoriesByWorld(worldSlug)
  return {
    user: state.auth.user,
    searchString: parseQ(ownProps.location),
    districtFilter: getDistrictFilter(state, ownProps.location),
    items: getItems(state, getLocationKey(state)),
    totalItems: getTotalItems(state),
    canLoadMoreItems: canLoadMoreItems(state),
    loading: getItemsLoading(state),
    loadingWorlds: state.categoriesAndWorlds.loading,
    world: getWorld(state, worldSlug),
    categories: getCategories(state),
    wantedLoadingById: state.allItems.wantedLoadingById,
  }
}

export default connect(mapStateToProps, {
  loadItems,
  loadMoreItems,
  putItemsInCache,
  unloadItems,
  iWant,
  iWantNot,
})(World)



// WEBPACK FOOTER //
// ./src/pages/World.js